export const INDIRECT_PLACEHOLDER = "INDIRECT_PLACEHOLDER";
// the default
export const DIRECT = "DIRECT";
